<template>

    <footer class="footer">

        <Banner2/>

        <div class="footer__middle">
            <div class="footer__middle-container">
                <div class="footer__middle-content">
                    <div class="footer__info">
                        <div class="footer__logo">
                            <img src="@/assets/logo_SBG.svg" :alt="t('sbg')">
                        </div>
                        <p class="footer__text">{{ t("footer_middle_text") }}</p>
                        <div class="footer__social">
                            <FooterSocial/>
                        </div>
                    </div>
                    <div class="footer__middle-content--menu">
                        <div class="footer__menu">
                            <FooterMenu :items="menu_items"/>
                        </div>
                        <div class="footer__categories">
                            <FooterCategories :items="category_items"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="footer__bottom">
            <div class="footer__bottom-container">
                <div class="footer__bottom-content">
                    <div class="footer__copyright">{{ t("footer_copyright") }}</div>
                    <div class="footer__menu-main">
                        <FooterMenuMain/>
                    </div>
                </div>
            </div>
        </div>

    </footer>

</template>

<script>
import axios from "@/axios";
import FooterMenu from "@/views/Components/FooterMenu.vue";
import FooterCategories from "@/views/Components/FooterCategories.vue";
import FooterSocial from "@/views/Components/FooterSocial.vue";
import FooterMenuMain from "@/views/Components/FooterMenuMain.vue";
import Banner2 from "@/views/Components/Banner2.vue";
import View from "@/views/View.vue"

export default {
    name: "Footer",
    components: {
        Banner2,
        FooterMenuMain,
        FooterSocial,
        FooterCategories,
        FooterMenu
    },
    extends: View,
    data: () => ({
        menu_items: [
            {
                id: 1001,
                id_top_position: null,
                title: "Aktualności",
                code: "articles",
                link: "/articles"
            },
            {
                id: 1002,
                id_top_position: null,
                title: "Wydarzenia",
                code: "events",
                link: "/events"
            },
            {
                id: 1003,
                id_top_position: null,
                title: "Informator",
                code: "informator",
                link: "/informator"
            },
            {
                id: 1004,
                id_top_position: null,
                code: "map",
                title: "Mapa",
                link: "/map"
            },
            {
                id: 1005,
                id_top_position: null,
                title: "Galerie",
                code: "galleries",
                link: "/galleries"
            },
            {
              id: 1006,
              id_top_position: null,
              title: "Multimedia",
              code: "multimedia",
              link: "/multimedia"
            },
            {
                id: 1008,
                id_top_position: null,
                title: "Kontakt",
                code: "contact",
                link: "/contact"
            }
        ],
        category_items: null,
    }),
    methods: {
        /**
         * Pobieranie elementów menu
         */
        loadMenuItems() {
            let params = {
                code: "main",
                scope_extra: "langs"
            }

            axios
                .get("/sitemenu/positionget", {params: params})
                .then(response => {
                    this.menu_items = response.data.data.reverse().filter(item => item.id_top_position === null)
                })
                .catch(error => {

                })
        },

        /**
         * Pobieranie kategorii
         */
        loadCategoryItems() {

            let params = {
                scope_extra: "langs"
            }

            axios
                .get("/place/categoryget", {params: params})
                .then(response => {
                    this.category_items = response.data.data.reverse()
                })
                .catch(error => {

                })
        }
    },
    mounted() {
        // this.loadMenuItems()
        this.loadCategoryItems()
    }
}
</script>

<style scoped lang="scss">

.footer {
  margin-top: auto;
  color: rgb(100, 100, 100);

  &__middle-container, &__bottom-container {
    max-width: calc(1140px + 100px);
    margin: 0 auto;
    padding: 0 calc(12px + 50px);

    @media screen and (max-width: 991px) {
      padding: 0 70px;
    }

    @media screen and (max-width: 767px) {
      padding: 0 40px;
    }
  }

  &__middle-content, &__bottom-content {
    display: flex;
    flex-direction: row;
    gap: 20px;

    @media screen and (max-width: 991px) {
      flex-direction: column;
    }
  }

  &__middle {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding: 100px 0 50px 0;

    &-content {

      &--menu {
        display: flex;
        flex-direction: row;
        gap: 20px;

        @media screen and (max-width: 991px) {
          width: 100%;
        }

        @media screen and (max-width: 767px) {
          flex-direction: column;
          gap: 20px;
        }
      }
    }
  }

  &__bottom {
    padding: 20px 0;

    &-content {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      @media screen and (max-width: 991px) {
        flex-direction: column;
      }
    }
  }

  &__info {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 60%;

    @media screen and (max-width: 991px) {
      width: 100%;
    }
  }

  &__logo {
    width: 100px;
    height: 100px;

    & > img {
      width: 100%;
    }
  }

  &__text {
    width: 80%;
    line-height: 1.75;

    @media screen and (max-width: 991px) {
      width: 100%;
    }
  }

  &__social {

  }

  &__menu {
    min-width: 190px;

    &-main {

    }
  }

  &__categories {
    min-width: 190px;
  }

  &__copyright {

  }
}

html.contrast {

  & .footer {
    color: #d2d2d2;
    background-color: #000;

    &__middle {
      border-bottom-color: #222;
    }
  }
}

</style>